import type React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { istVerdichtungsZusammenfassung, ohneTranskriptPfad } from '../../../../shared/verdichtung-zusammenfassung';

export { istVerdichtungsZusammenfassung };

/**
 * Die automatische Verdichtungs-Zusammenfassung als eingeklappter Block statt als
 * Nutzernachricht (Rafael, 03.10.2026 16:35 UTC: "Zusammenfassung eingeklappt").
 *
 * Fuer ALLE eingeklappt. Den rohen Transkript-Pfad sieht nur ein Admin (bzw. Dev ohne
 * Anmeldung); der Server entfernt ihn fuer Nicht-Admins schon an der Quelle — hier
 * zusaetzlich, weil live gestreamte Nachrichten nicht ueber diesen Weg kommen.
 */
export function VerdichtungsBlock({ text, timestamp, renderText }: {
  text: string;
  timestamp?: string;
  renderText: (text: string) => React.ReactNode;
}) {
  const { user, authEnabled } = useAuth();
  const pfadZeigen = authEnabled === false || user?.role === 'admin';
  const inhalt = pfadZeigen ? text : ohneTranskriptPfad(text);
  return (
    <div data-verdichtung="1" style={{ padding: '8px 16px', borderBottom: '1px solid var(--tn-border)' }}>
      <details>
        <summary style={{ cursor: 'pointer', fontSize: 12, color: 'var(--tn-text-muted)', userSelect: 'none' }}>
          Zusammenfassung des bisherigen Gesprächs
          {timestamp && (
            <span style={{ fontSize: 10, marginLeft: 8 }}>{new Date(timestamp).toLocaleTimeString()}</span>
          )}
        </summary>
        <div style={{ marginTop: 8, fontSize: 13, color: 'var(--tn-text-subtle)', lineHeight: '1.6' }}>
          {renderText(inhalt)}
        </div>
      </details>
    </div>
  );
}
